import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import StickyCallBar from "@/components/site/StickyCallBar";

export default function SiteLayout({ children, testId }) {
  return (
    <div className="min-h-screen text-[#1F2937] font-body bg-white pb-14 md:pb-0" data-testid={testId}>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppFab />
      <StickyCallBar />
    </div>
  );
}
